import { createStore } from 'vuex'

export default createStore({
  state: {
    user: null,
    applicant: {},
    isPending: false,
  },
  getters: {

  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
